export default __webpack_public_path__ + "static/media/slide_portalcliente_005.0a15f27b.png";